module.exports = __webpack_public_path__ + "img/Namibia.f3af90c9.gif";